import React, { useState, useEffect } from 'react';

// SERVICES
import { getAllColors } from 'services/tileService';

const ColorPicker = ({ onColorSelected, initialColorHex }) => {
    const [colorGroups, setColorGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [shadeIndex, setShadeIndex] = useState(0);

    useEffect(() => {
        async function fetchColors() {
            try {
                const response = await getAllColors();
                const filtered = response.data.filter(color =>
                    color.TCO_NAME !== 'Noir' && color.TCO_NAME !== 'Blanc'
                );

                const grouped = filtered.reduce((acc, color) => {
                    const group = color.TCO_NAME;
                    if (!acc[group]) acc[group] = [];
                    acc[group].push(color);
                    return acc;
                }, {});

                Object.keys(grouped).forEach(group => {
                    grouped[group].sort((a, b) => {
                        const order = ['default', 'Variante 1', 'Variante 2', 'Variante 3'];
                        return order.indexOf(a.TCO_SUBNAME) - order.indexOf(b.TCO_SUBNAME);
                    });
                });

                setColorGroups(grouped);
            } catch (err) {
                console.error("Erreur lors de la récupération des couleurs", err);
            }
        }

        fetchColors();
    }, []);

    useEffect(() => {
        if (!initialColorHex || Object.keys(colorGroups).length === 0) return;

        const found = Object.entries(colorGroups).find(([_, shades]) =>
            shades.some(c => c.TCO_HEXA === initialColorHex)
        );

        if (found) {
            const [groupName, shades] = found;
            setSelectedGroup(groupName);
            const index = shades.findIndex(c => c.TCO_HEXA === initialColorHex);
            setShadeIndex(index);
        } else {
            const firstGroup = Object.keys(colorGroups)[0];
            setSelectedGroup(firstGroup);
            setShadeIndex(0);
        }
    }, [initialColorHex, colorGroups]);

    const handleGroupClick = (groupName) => {
        setSelectedGroup(groupName);
        setShadeIndex(0);
        onColorSelected(colorGroups[groupName][0]);
    };

    const handleSliderChange = (e) => {
        const index = parseInt(e.target.value);
        setShadeIndex(index);
        onColorSelected(colorGroups[selectedGroup][index]);
    };

    if (!selectedGroup || !colorGroups[selectedGroup]) return null;

    const currentShades = colorGroups[selectedGroup];
    const gradient = `linear-gradient(to right, ${currentShades.map(c => c.TCO_HEXA).join(', ')})`;
    const thumbColor = currentShades[shadeIndex].TCO_HEXA;

    return (
        <div className="p-4">
            <h2 className="text-center font-bold text-lg mb-4">Choisissez une couleur</h2>
            <div className="flex justify-around mb-4">
                {Object.entries(colorGroups).map(([group, shades]) => (
                    <div
                        key={group}
                        className={`size-8 rounded-full border-2 cursor-pointer transition-transform ${
                            selectedGroup === group ? 'border-blanc scale-110' : 'border-transparent'
                        }`}
                        style={{ backgroundColor: shades[0].TCO_HEXA }}
                        onClick={() => handleGroupClick(group)}
                    />
                ))}
            </div>
            <div className="relative w-full px-2 mt-2">
                <input
                    type="range"
                    min={0}
                    max={currentShades.length - 1}
                    value={shadeIndex}
                    onChange={handleSliderChange}
                    className="w-full h-2 appearance-none bg-transparent rounded-full"
                    style={{ backgroundImage: gradient }}
                />
                <style jsx>
                    {`
                        input[type="range"]::-webkit-slider-thumb {
                            appearance: none;
                            height: 16px;
                            width: 16px;
                            border-radius: 50%;
                            background-color: ${thumbColor};
                            border: 2px solid white;
                            cursor: pointer;
                            margin-top: -7px;
                        }
                        input[type="range"]::-moz-range-thumb {
                            height: 16px;
                            width: 16px;
                            border-radius: 50%;
                            background-color: ${thumbColor};
                            border: 2px solid white;
                            cursor: pointer;
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default ColorPicker;